import {
    DataTableCustomized,
    type DataTableAction,
    type DataTableColumn,
} from '@/components/ui/data-table-customized'
import {
    Product,
    ProductGroupWithProducts,
} from '@/modules/Settings/types/product'
import React from 'react'
import ExpandedProductDetail from './ExpandedProductDetail'

/** Expanded content: 2 sub-tables for main products & addons */
const ExpandedProductGroup: React.FC<{
    row: ProductGroupWithProducts
    productColumns: DataTableColumn<Product>[]
    productActions: DataTableAction<Product>[]
    t: (key: string) => string
}> = ({ row, productColumns, productActions, t }) => {
    const mainProducts = row.products.filter((p) => !p.is_product_addon)
    const addonProducts = row.products.filter((p) => p.is_product_addon)

    return (
        <div className="space-y-2 py-2">
            {mainProducts.length > 0 && (
                <div>
                    <div className="px-2 pb-1">
                        <span className="text-xs font-semibold text-muted-foreground">
                            {t('main-products')} ({mainProducts.length})
                        </span>
                    </div>
                    <DataTableCustomized<Product>
                        columns={productColumns}
                        rows={mainProducts}
                        rowKey={(p) => p.product_id}
                        emptyMessage={t('no-data')}
                        actions={productActions}
                        expandable={{
                            expandedRowRender: (product) => (
                                <ExpandedProductDetail
                                    productId={product.product_id}
                                    readOnly={
                                        product.product_price_model !== 'bundle'
                                    }
                                />
                            ),
                            rowExpandable: () => true,
                        }}
                        bordered
                    />
                </div>
            )}
            {addonProducts.length > 0 && (
                <div>
                    <div className="px-2 pb-1">
                        <span className="text-xs font-semibold text-muted-foreground">
                            {t('addon-products')} ({addonProducts.length})
                        </span>
                    </div>
                    <DataTableCustomized<Product>
                        columns={productColumns}
                        rows={addonProducts}
                        rowKey={(p) => p.product_id}
                        emptyMessage={t('no-data')}
                        actions={productActions}
                        expandable={{
                            expandedRowRender: (product) => (
                                <ExpandedProductDetail
                                    productId={product.product_id}
                                    readOnly={
                                        product.product_price_model !== 'bundle'
                                    }
                                />
                            ),
                            rowExpandable: () => true,
                        }}
                        bordered
                    />
                </div>
            )}
        </div>
    )
}

export default ExpandedProductGroup
